import { Map } from "immutable";
import { IStore } from "reducers";
import { getSnapshot } from "../mutate";

export const getReviewPlanFromState = (
    state: IStore,
    collectionId: string,
    poi?: string,
): { reviewPlanKey: string; reviewPlan: Map<string, Map<string, string>> } => {
    const collection = state.mutate.snapshots && state.mutate.snapshots.get(collectionId);
    const reviewPlansRefs = collection ? collection.getIn(["review_plan_refs", "struct_value"], Map()) : Map();
    const reviewPlansRefValue = reviewPlansRefs.valueSeq();
    const reviewPlansRef = reviewPlansRefValue && reviewPlansRefValue.get(0);
    const reviewPlanKey = reviewPlansRef && reviewPlansRef.get("object_id");
    const reviewPlanSnapshot = reviewPlanKey ? getSnapshot(state, reviewPlanKey, poi) : Map();
    const reviewPlan = reviewPlanSnapshot ? reviewPlanSnapshot.getIn(["plan_detail", "map", "fields"], Map()) : Map();
    return { reviewPlanKey, reviewPlan };
};
